const firebaseConfig = {
  apiKey: "AIzaSyDkXnhWapRu-S7ojUofFr20mqtq1XWPYd4",
  authDomain: "house-rent-47355.firebaseapp.com",
  projectId: "house-rent-47355",
  storageBucket: "house-rent-47355.appspot.com",
  messagingSenderId: "206092546971",
  appId: "1:206092546971:web:f1cb81e5ba58899c7a673e",
};
export default firebaseConfig;

/* const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};
export default firebaseConfig; */
